import { FunctionComponent, PropsWithChildren } from 'react';
import { PageNavigationDesktop } from './components/PageNavigationDesktop';
import { PageNavigationMobile } from './components/PageNavigationMobile';
import { PageNavigationProps } from './types';

export const PageNavigation: FunctionComponent<PropsWithChildren<PageNavigationProps>> = ({ links }) => {
  const windowWidth = window.innerWidth ?? document.documentElement.clientWidth ?? document.body.clientWidth;

  if (windowWidth > 500) {
    return <PageNavigationDesktop links={links} />;
  }
  return <PageNavigationMobile links={links} />;
};
